import { useState } from 'react'
import styled from 'styled-components'

import Button from 'components/Button'
import Modal from 'components/Modal'

export type CsvFormatGuideDefinition = {
  title: string
  layouts: string[]
  rules: string[]
  examples: Array<{
    label: string
    fileName: string
    csv: string
  }>
}

type Props = {
  definition: CsvFormatGuideDefinition
  className?: string
}

export default function CsvFormatGuide({ definition, className }: Props) {
  const [open, setOpen] = useState(false)

  return (
    <div className={className}>
      <GuideButton tertiary type="button" onClick={() => setOpen(true)}>
        Wymagany format pliku
      </GuideButton>
      <Modal isOpen={open} onClose={() => setOpen(false)}>
        <h1>{definition.title}</h1>
        <GuideContent>
          {definition.layouts.map(layout => (
            <p key={layout}>{layout}</p>
          ))}
          <ul>
            {definition.rules.map(rule => (
              <li key={rule}>{rule}</li>
            ))}
          </ul>
          {definition.examples.map(example => (
            <a
              key={example.fileName}
              href={`data:text/csv;charset=utf-8,${encodeURIComponent(example.csv)}`}
              download={example.fileName}
            >
              {example.label}
            </a>
          ))}
        </GuideContent>
      </Modal>
    </div>
  )
}

const GuideButton = styled(Button)`
  padding: 4px 0;
  text-transform: none;
`

const GuideContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-width: 640px;
  text-align: left;

  ul {
    padding-left: 20px;
  }
`
